<template>
  <b-container class="container">
    <!-- Registration Email Template Section -->
    <b-card title="Email Template" class="mb-2 mt-2">
      <b-row>
        <b-col>
          <label>Registration Email Subject</label>
          <b-form-input v-model="emailsubject" maxlength="150"> </b-form-input>
          <b-collapse v-model="subject_error">
            <label class="error">Subject is required</label>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label>Registration Email Text</label>
          <b-form-textarea rows="3" v-model="emailtext" maxlength="600">
          </b-form-textarea>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            v-bind:disabled="isSubmitDisabled"
            v-on:click="update"
            variant="primary"
            size="sm"
          >
            Update Email Template
          </b-button>
          <b-collapse v-model="event_success">
            <label class="message">Email content updated</label>
          </b-collapse>
          <b-collapse v-model="event_failure">
            <label class="error">An error occurred</label>
          </b-collapse>
        </b-col>
      </b-row>
    </b-card>

    <!-- Import Attendees Section -->
    <b-card title="Bulk Registration" class="mb-2 mt-2">
      <b-row align-v="center">
        <b-col sm="6">
          <div @click="downloaded_file">
            <a download="info.txt" id="downloadlink" style="display: none">
              Click To Download File
            </a>
          </div>
          <b-input-group class="mt-3">
            <b-input
              v-if="!saveFile"
              placeholder="Save CSV Filename"
              v-model="saveFileName"
              size="sm"
            >
            </b-input>
            <b-button
              v-if="!saveFile"
              size="sm"
              :disabled="!enableSave()"
              :variant="enableSave() ? 'primary' : 'secondary'"
              @click="make_save_file"
            >
              Save
            </b-button>
          </b-input-group>
        </b-col>
        <b-col sm="6" class="pull-right">
          <b-input-group class="mt-3">
            <b-form-file
              v-if="!saveFile"
              placeholder="Load CSV Filename"
              drop-placeholder="-"
              browse-text=" "
              v-model="loadFile"
              size="sm"
              :state="Boolean(loadFile)"
            >
            </b-form-file>
            <b-button
              v-if="!saveFile"
              size="sm"
              :disabled="!loadFile"
              :variant="loadFile ? 'primary' : 'secondary'"
              @click="load_from_file"
            >
              Load
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>

    <!--  
  Attendees  Section starts
  handles CRUD  
  -->
    <b-card title="Attendees" class="mb-2 mt-2">
      <b-row>
        <!--
    <b-col>
      <label>Select Ticket tier to show attendees</label>
    </b-col>
    <b-col>
      <b-form-select v-model="selectedgroup">
        <b-form-select-option v-for="group in this.$parent.event.groups.slice(1)" :value="group.name">{{ to_disp_name(group.name) }}</b-form-select-option>
      </b-form-select>
    </b-col>
-->
        <b-col>
          <b-button variant="primary" size="sm" @click="attendee_new">
            New attendee
          </b-button>
        </b-col>
        <b-col> </b-col>
        <b-col>
          <b-button
            class="float-right"
            variant="primary"
            size="sm"
            @click="get_attendees"
          >
            Refresh
          </b-button>
        </b-col>
      </b-row>

      <div class="mt-2">
        <b-table
          striped
          hover
          show-empty
          stacked="sm"
          ref="userstab"
          :items="atts"
          :fields="attFields"
          small
        >
          <template v-slot:cell(em)="att">
            <a @click.prevent="attendee_open(att.item)" href="">
              {{ att.item.em }}
            </a>
          </template>
          <template v-slot:cell(name)="att">
            {{ att.item.name }}
          </template>
          <template v-slot:cell(tiers)="att">
            {{ att.item.tiers }}
          </template>
          <template v-slot:cell(ctrl)="att">
            <b-button
              class="btn_reg_table"
              size="sm"
              @click="attendee_delete(att.item)"
              variant="danger"
            >
              Delete
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>

    <!-- Reg. Question CRD   -->
    <b-card title="Questions" class="mb-2 mt-2">
      <b-row>
        <b-col>
          <b-button variant="primary" size="sm" @click="add_question">
            New Question
          </b-button>
        </b-col>
        <b-col> </b-col>
      </b-row>

      <div class="mt-2">
        <b-table
          striped
          hover
          show-empty
          stacked="sm"
          ref="userstab"
          :items="questions_list"
          :fields="qnFields"
          small
        >
          <template v-slot:cell(index)="att">
            {{ att.item.q }}
          </template>
          <template v-slot:cell(ctrl)="att">
            <b-button
              class="btn_reg_table"
              size="sm"
              @click="question_delete(att.index)"
              variant="danger"
            >
              Delete
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>

    <!-- Attendee Modal -->
    <b-modal id="bv-att-card" size="lg" hide-footer>
      <div style="padding: 1vw 0px">
        <b-row v-if="!edit_att.is_new">
          <b-col>
            <div>Email: {{ edit_att.em }}</div>
          </b-col>
        </b-row>
        <b-row v-if="edit_att.is_new">
          <b-col sm="2"> Email </b-col>
          <b-col>
            <b-input size="sm" placeholder="Email" v-model="edit_att.em">
            </b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="2"> Name </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Display Name"
              v-model="edit_att.name"
            >
            </b-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b> Registration Tiers </b>3
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <span v-for="item in edit_att.tiers">
              <b-form-checkbox
                v-model="item.enable"
                value="true"
                unchecked-value="false"
              >
                {{ item.dname }}
              </b-form-checkbox>
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b> Room Access </b>
            <b-table
              striped
              hover
              show-empty
              stacked="sm"
              :items="edit_att.access"
              :fields="attaccessFields"
              small
            >
              <template v-slot:cell(roomname)="acc">
                {{ room_dname($parent.event, acc.item.roomname) }}
              </template>
              <template v-slot:cell(startep)="acc">
                {{ room_time(acc.item.startep) }}
              </template>
              <template v-slot:cell(endep)="acc">
                {{ room_time(acc.item.endep) }}
              </template>
              <template v-slot:cell(is_mod)="acc">
                {{ acc.item.is_mod ? "True" : "False" }}
              </template>
              <template v-slot:cell(ctrl)="acc">
                <b-button
                  size="sm"
                  style="padding: 0 0.1rem; margin: 0"
                  variant="outline-danger"
                  @click="rem_acl(acc.item)"
                >
                  Del
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <div class="mt-3">
          <b-button-group class="">
            <b-button class="sm" @click="attendee_update">
              {{ edit_att.is_new ? "Add" : "Update" }}
            </b-button>
          </b-button-group>
          <b-button-group class="float-right">
            <b-button
              class="sm"
              @click="$bvModal.hide('bv-att-card')"
              variant="danger"
            >
              Cancel
            </b-button>
          </b-button-group>
        </div>
      </div>
    </b-modal>

    <!-- Question Modal.. -->
    <b-modal id="bv-qn-card" size="lg" hide-footer>
      <div style="padding: 1vw 0px">
        <b-row>
          <b-col sm="2"> Question </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Enter Question"
              v-model="question.qn"
            >
            </b-input>
          </b-col>
        </b-row>

        <div class="mt-3">
          <b-button-group class="">
            <b-button class="sm" @click="question_update"> Add </b-button>
          </b-button-group>
          <b-button-group class="float-right">
            <b-button
              class="sm"
              @click="$bvModal.hide('bv-qn-card')"
              variant="danger"
            >
              Cancel
            </b-button>
          </b-button-group>
        </div>
      </div>
    </b-modal>
    <!-- Question Modal ends.. -->
  </b-container>
</template>
<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import { CSV } from "../csv.js";

export default {
  name: "update_registration",
  data() {
    return {
      selectedgroup: "",
      attendees: "",
      emailsubject: "",
      emailtext: "",
      subject_error: false,
      isSubmitDisabled: false,
      event_success: false,
      event_failure: false,
      edit_att: { em: "", name: "", tiers: [] },
      atts: [],
      attFields: [
        { key: "em", label: "Email" },
        { key: "name", label: "Name" },
        { key: "acnt", label: "Access Count" },
        { key: "ctrl", label: "" },
      ],
      attaccessFields: [
        { key: "roomname", label: "Room" },
        { key: "startep", label: "Start" },
        { key: "endep", label: "End" },
        { key: "is_mod", label: "Mod" },
        { key: "ctrl", label: "" },
      ],
      //import csv
      saveFile: null,
      saveFileName: "",
      loadFile: null,

      //Questions
      question: [],
      questions_list: [],
      qnFields: [
        { key: "q", label: "Question" },
        { key: "ctrl", label: "" },
      ],
      log: console.log,
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    to_disp_name: function (groupname) {
      var idx = groupname.indexOf("-");
      var subs = groupname.substring(idx + 1);
      return subs.replaceAll("-", " ");
    },
    get_attendees: function() {
        window.wss_send(vx, "adm_event_list_attendee", {
          event: {
           id: this.$parent.event.id
          },
        //group: {
        //   name: this.selectedgroup
        //}
      });
    },
    update: function () {    
	if (this.emailsubject == '') {
		this.subject_error = true;
		return;
	} else {
		this.subject_error = false;
	}
        let event = this.$parent.event;
        let er = {};        
        er.subject = this.emailsubject;
        er.emailtext = this.emailtext;
	event.email_reg = er;
        window.wss_send(vx, "adm_event_set", {rtag:"registration",
            event: {
              id:event.id,
              email_reg : {
                subject : er.subject,
                emailtext : er.emailtext
              }
            }
        });
    },

    // Delete Attendee
    attendee_delete: function (att) {
      let vue = this;
      let param = {
         event: {
           id: vue.$parent.event.id
         }, att: {
            em: att.em,
         }
      };
      window.wss_send(vx, "adm_event_rem_attendee", param);
    },

    // Add new Attendee
    attendee_new: function () {
      let vue = this;
      //vue.edit_att = {};
      vue.edit_att.is_new = true;
      vue.edit_att.em = "";
      vue.edit_att.name = "";
      vue.edit_att.tiers = [];
      vue.$parent.event.groups.forEach(function (g) {
        vue.edit_att.tiers.push({
          dname: g.dname,
          enable: false,
        });
      });
      vue.edit_att.access = [];
      this.$bvModal.show("bv-att-card");
    },

    // Open  attendee Edit
    attendee_open: function (att) {
      let vue = this;
      //vue.edit_att = {};
      vue.edit_att.is_new = false;
      vue.edit_att.em = att.em;
      vue.edit_att.name = att.name;
      vue.edit_att.tiers = [];
      console.log(JSON.stringify(vue.$parent.event.groups));
      vue.$parent.event.groups.forEach(function (g) {
        let tier = {
          dname: g.dname,
          enable: false,
        };
        att.groups.forEach(function (ag) {
          if (g.dname == ag.g.dname) {
            tier.enable = true;
          }
        });
        vue.edit_att.tiers.push(tier);
      });

      console.log(JSON.stringify(vue.edit_att.tiers));
      vue.edit_att.access = att.access;
      vue.$bvModal.show("bv-att-card");
    },

    rem_acl: function (item) {
      let vue = this;
      console.log(JSON.stringify(item));
      window.wss_send(vx, "adm_event_add_attendee", {
       event: {
         id: item.eventid,
       },
       att: {
         em: vue.edit_att.em,
         access: [{
              id: item.id,
              rem: true,
            },
          ],
        },
      });
      vue.edit_att.access = vue.edit_att.access.filter(function (acc) {
        if (acc.id == item.id) {
          return false;
        }
        return true;
      });
    },

    // Update attendee
    attendee_update: function () {
      let vue = this;
      if (!vue.edit_att.em) {
        return;
      }
      let param = {
         event: {
           id: vue.$parent.event.id
         }, att: {
            em: vue.edit_att.em,
            name: vue.edit_att.name,
            access: [], 
         }
      };
      /* Handles groups */
      vue.edit_att.tiers.forEach(function (tier) {
        console.log(JSON.stringify(tier));
        vue.$parent.event.groups.forEach(function (g) {
          console.log(g.dname);
          if (g.dname == tier.dname) {
            //console.log(JSON.stringify(tier.enable));
            param.att.access.push({
              groupname: g.name,
              rem: !tier.enable || tier.enable == "false",
            });
          }
        });
      });
      /* att.access only has rooms */
      vue.edit_att.access.forEach(function (acc) {
        param.att.access.push(acc);
      });

      window.wss_send(vx, "adm_event_add_attendee", param);
      this.$bvModal.hide("bv-att-card");
    },
    room_time: function (ep) {
      if (!ep) {
        return "-";
      }
      let tm = new Date(ep);
      let opt = {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return tm.toLocaleDateString("en-US", opt);
    },
    room_dname: utils.room_dname,
    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      if (vue.$parent.event.email_reg) {
        vue.emailsubject = vue.$parent.event.email_reg.subject;
        vue.emailtext = vue.$parent.event.email_reg.emailtext;
        if (
          vue.$parent.event.email_reg.ques &&
          vue.$parent.event.email_reg.ques.length > 0
        )
          vue.questions_list = vue.$parent.event.email_reg.ques;
        console.log("setup", vue.questions_list);
      }
      vue.get_attendees();
    },

    //save csv
    make_save_file: function () {
      let vue = this;
      let j = {
        fields: [{ id: "email" }, { id: "name" }, { id: "tiers" }],
        records: [],
      };
      let csv = new CSV();
      vue.atts.forEach(function (p) {
        let jp = {};
        jp.email = p.em;
        jp.name = p.name;
        const tiers = [];
        p["groups"].map((group) => {
          tiers.push(group.g.dname);
        });
        if (tiers.length === 2) {
          jp.tiers = "all";
        } else {
          jp.tiers = tiers[0] || "";
        }
        j.records.push(jp);
      });
      let txt = csv.serialize(j);
      let data = new Blob([txt], { type: "text/csv" });
      if (vue.saveFile !== null) {
        window.URL.revokeObjectURL(vue.saveFile);
      }
      vue.saveFile = window.URL.createObjectURL(data);

      let link = document.getElementById("downloadlink");
      link.href = vue.saveFile;
      link.style.display = "block";
      link.download = "" + vue.saveFileName;
    },

    //download csv
    downloaded_file: function () {
      let vue = this;
      window.setTimeout(function () {
        let link = document.getElementById("downloadlink");
        link.href = null;
        link.style.display = "none";
        if (vue.saveFile !== null) {
          window.URL.revokeObjectURL(vue.saveFile);
        }
        vue.saveFile = null;
      }, 2000);
    },

    //Import CSV
    load_from_file: function () {
      let vue = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        let contents = e.target.result;
        let csv = new CSV();
        let c = csv.parse(contents);
        let email_idx = 0,
          uid_idx;
        c.r.forEach(function (v, idx) {
          if (idx == 0) {
            return;
          }

          let param = {
            subd: window.vx.subd,
            event: {
              id: vue.$parent.event.id,
            },
            att: {
              em: v[0],
              name: v[1],
              access: [],
            },
          };

          //Access Groups
          vue.$parent.event.groups.forEach(function (g) {
            if (v[2] == "all") {
              /* all: add every group */
              param.att.access.push({
                groupname: g.name,
              });
            } else if (v[2] == "freeaccess" && g.is_free) {
              /* freeaccess: add only free groups */
              param.att.access.push({
                groupname: g.name,
              });
            }
          });
          window.wss_send(vx, "adm_event_add_attendee", param);
        });
        vue.loadFile = null;
        vue.$parent.notification = {
          alertCountDown: 4,
          alertVariant: "success",
          alertMessage: "Successfully loaded",
        };
      };
      reader.readAsText(vue.loadFile);
    },

    // Enable Buttons states
    enableSave: function () {
      let vue = this;
      if (vue.saveFile) {
        return false;
      }
      if (vue.loadFile) {
        return false;
      }
      if (!vue.saveFileName) {
        return false;
      }
      return true;
    },

    // Add new Question
    add_question: function () {
      let vue = this;
      vue.question.is_new = true;
      vue.question.qn = "";
      this.$bvModal.show("bv-qn-card");
    },

    // Delete Question
    question_delete: function (index) {
      this.$parent.event.email_reg.ques.splice(index, 1);
      let event = {email_reg:[],delta:true};
      event.id = this.$parent.event.id;
      event.email_reg =  this.$parent.event.email_reg;
      utils.event_modified(this.$parent.event);
      event.ver =  this.$parent.event.ver;
      event.pver = this.$parent.event.pver;
    window.wss_send(vx, "adm_event_set", {
        rtag: "registration",
        subd: window.vx.subd,
        event:event,
      });
    },

    // Update Question
    question_update: function () {
      if (this.question.qn == "") {
        this.qn_error = true;
        return;
      } else {
        this.qn_error = false;
      }

      let event = this.$parent.event;
      let er = {};
      er.q = this.question.qn;
      er.kind = "text"; // TODO : from form
      console.log("question list", this.questions_list);
      this.questions_list.push(er);
      event.email_reg.ques = this.questions_list;
      window.wss_send(vx, "adm_event_set", {
        rtag: "registration",
        subd: window.vx.subd,
        event: {
          id: event.id,
          email_reg : {
            ques : event.email_reg.ques
          }
        },
      });
      this.$bvModal.hide("bv-qn-card");
      this.question.qn = "";
    },
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "update_attendees");
  },
  mounted() {
    let vue = this;
    vue.event_success = false;
    vue.setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "update_attendees",
      routes: {
        adm_event_list_attendee: function (msg) {
          if (msg.data.error) {
            console.log(msg.data.error);
            return;
          }
          let atts = [];
          msg.data.attendees.forEach(function (att) {
            console.log(JSON.stringify(att));
            let a = { groups: [] };
            a.name = att.name;
            a.em = att.em;
            a.access = [];
            a.acnt = 0;
            att.access.forEach(function (acc) {
              if (acc.groupname) {
                let g = vue.$parent.event.ghash[acc.groupname];
                if (!g) {
                  return; // Tier was likely deleted
                }
                a.groups.push({
                  name: acc.groupname,
                  g: g,
                });
              } else if (acc.roomname) {
                a.access.push(acc);
              }
              a.acnt++;
            });
            atts.push(a);
          });
          vue.atts = atts;
        },
        adm_event_add_attendee: function (msg) {
          vue.get_attendees();
        },
        adm_event_rem_attendee: function (msg) {
          vue.get_attendees();
        },
        adm_event_set: function (msg) {
          if (msg.rtag != "registration") return;
          if (msg.data.error) {
            console.log(msg.data.error);
            vue.event_failure = true;
            vue.isSubmitDisabled = false;
            return;
          }
          vue.event_success = true;
          vue.isSubmitDisabled = false;
        },
      },
    });
  },
};
</script>

<style lang="scss">
.btn_reg_table {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}
</style>